/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CustomerContactsTabData } from "./CustomerContactsTabData";
import {
  CustomerContactsTabDataFromJSON,
  CustomerContactsTabDataFromJSONTyped,
  CustomerContactsTabDataToJSON,
  CustomerContactsTabDataToJSONTyped,
} from "./CustomerContactsTabData";
import type { CarrierRepInformation } from "./CarrierRepInformation";
import {
  CarrierRepInformationFromJSON,
  CarrierRepInformationFromJSONTyped,
  CarrierRepInformationToJSON,
  CarrierRepInformationToJSONTyped,
} from "./CarrierRepInformation";

/**
 *
 * @export
 * @interface ContactTabData
 */
export interface ContactTabData {
  /**
   *
   * @type {CustomerContactsTabData}
   * @memberof ContactTabData
   */
  customerContacts: CustomerContactsTabData;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof ContactTabData
   */
  carrierShippingContacts: { [key: string]: Array<string> };
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof ContactTabData
   */
  carrierBillingContacts: { [key: string]: Array<string> };
  /**
   *
   * @type {string}
   * @memberof ContactTabData
   */
  carrierCustomerServiceNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof ContactTabData
   */
  advanceCustomerServiceNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof ContactTabData
   */
  beyondCustomerServiceNumber?: string | null;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof ContactTabData
   */
  advanceShippingContacts?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof ContactTabData
   */
  beyondShippingContacts?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {CarrierRepInformation}
   * @memberof ContactTabData
   */
  carrierRepInformation?: CarrierRepInformation | null;
  /**
   *
   * @type {Array<CarrierRepInformation>}
   * @memberof ContactTabData
   */
  additionalCarrierReps?: Array<CarrierRepInformation> | null;
}

/**
 * Check if a given object implements the ContactTabData interface.
 */
export function instanceOfContactTabData(
  value: object,
): value is ContactTabData {
  if (!("customerContacts" in value) || value["customerContacts"] === undefined)
    return false;
  if (
    !("carrierShippingContacts" in value) ||
    value["carrierShippingContacts"] === undefined
  )
    return false;
  if (
    !("carrierBillingContacts" in value) ||
    value["carrierBillingContacts"] === undefined
  )
    return false;
  return true;
}

export function ContactTabDataFromJSON(json: any): ContactTabData {
  return ContactTabDataFromJSONTyped(json, false);
}

export function ContactTabDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ContactTabData {
  if (json == null) {
    return json;
  }
  return {
    customerContacts: CustomerContactsTabDataFromJSON(json["customerContacts"]),
    carrierShippingContacts: json["carrierShippingContacts"],
    carrierBillingContacts: json["carrierBillingContacts"],
    carrierCustomerServiceNumber:
      json["carrierCustomerServiceNumber"] == null
        ? undefined
        : json["carrierCustomerServiceNumber"],
    advanceCustomerServiceNumber:
      json["advanceCustomerServiceNumber"] == null
        ? undefined
        : json["advanceCustomerServiceNumber"],
    beyondCustomerServiceNumber:
      json["beyondCustomerServiceNumber"] == null
        ? undefined
        : json["beyondCustomerServiceNumber"],
    advanceShippingContacts:
      json["advanceShippingContacts"] == null
        ? undefined
        : json["advanceShippingContacts"],
    beyondShippingContacts:
      json["beyondShippingContacts"] == null
        ? undefined
        : json["beyondShippingContacts"],
    carrierRepInformation:
      json["carrierRepInformation"] == null
        ? undefined
        : CarrierRepInformationFromJSON(json["carrierRepInformation"]),
    additionalCarrierReps:
      json["additionalCarrierReps"] == null
        ? undefined
        : (json["additionalCarrierReps"] as Array<any>).map(
            CarrierRepInformationFromJSON,
          ),
  };
}

export function ContactTabDataToJSON(json: any): ContactTabData {
  return ContactTabDataToJSONTyped(json, false);
}

export function ContactTabDataToJSONTyped(
  value?: ContactTabData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    customerContacts: CustomerContactsTabDataToJSON(value["customerContacts"]),
    carrierShippingContacts: value["carrierShippingContacts"],
    carrierBillingContacts: value["carrierBillingContacts"],
    carrierCustomerServiceNumber: value["carrierCustomerServiceNumber"],
    advanceCustomerServiceNumber: value["advanceCustomerServiceNumber"],
    beyondCustomerServiceNumber: value["beyondCustomerServiceNumber"],
    advanceShippingContacts: value["advanceShippingContacts"],
    beyondShippingContacts: value["beyondShippingContacts"],
    carrierRepInformation: CarrierRepInformationToJSON(
      value["carrierRepInformation"],
    ),
    additionalCarrierReps:
      value["additionalCarrierReps"] == null
        ? undefined
        : (value["additionalCarrierReps"] as Array<any>).map(
            CarrierRepInformationToJSON,
          ),
  };
}
